<div class="flex flex-col items-center px-8 py-8">
    <div class="w-16 h-16 rounded-full flex items-center justify-center mb-5" [ngClass]="getIconConfig().bg">
        <mat-icon class="icon-size-10" [ngClass]="getIconConfig().color" [svgIcon]="getIconConfig().icon"></mat-icon>
    </div>

    <h3 class="font-remote font-[600] text-[20px] text-gray-800 mb-2 text-center">{{ data.title }}</h3>

    <p class="font-inter font-[400] text-[14px] text-gray-500 text-center mb-6">{{ data.message }}</p>

    <ng-container *ngIf="data.warningMessage">
        <div class="w-full rounded-xl bg-amber-50 border border-amber-200 px-4 py-3 mb-6 flex items-start gap-2.5 animate-fadeIn">
            <mat-icon class="icon-size-5 text-amber-600 flex-shrink-0 mt-0.5" svgIcon="heroicons_outline:exclamation"></mat-icon>
            <span class="font-inter font-[400] text-[13px] text-amber-700 leading-relaxed">{{ data.warningMessage }}</span>
        </div>
    </ng-container>

    <div class="flex gap-3 w-full">
        <ng-container *ngIf="data.noButton.use">
            <button (click)="noAction()" class="flex-1 flex items-center justify-center px-5 py-2.5 rounded-3xl bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors">
                <span class="font-remote font-[500] text-[14px] text-gray-700">{{ data.noButton.label || 'Não' }}</span>
            </button>
        </ng-container>

        <ng-container *ngIf="data.cancelButton.use">
            <button (click)="cancelAction()" class="flex-1 flex items-center justify-center px-5 py-2.5 rounded-3xl bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors">
                <span class="font-remote font-[500] text-[14px] text-gray-700">{{ data.cancelButton.label || 'Cancelar' }}</span>
            </button>
        </ng-container>

        <ng-container *ngIf="data.yesButton.use">
            <button (click)="yesAction()"
                    [disabled]="loading"
                    [ngClass]="{
                        'bg-[#0061ff] hover:bg-[#2f75e7]': !data.yesButton.color,
                        'bg-red-500 hover:bg-red-600': data.yesButton.color === 'red'
                    }"
                    class="flex-1 flex items-center justify-center px-5 py-2.5 rounded-3xl cursor-pointer transition-colors">
                <span *ngIf="!loading" class="font-remote font-[500] text-[14px] text-white">{{ data.yesButton.label || 'Sim' }}</span>
                <mat-progress-spinner *ngIf="loading" [diameter]="20" [mode]="'indeterminate'" class="spinner-white"></mat-progress-spinner>
            </button>
        </ng-container>

        <ng-container *ngIf="data.closeButton?.use">
            <button (click)="close()" class="flex-1 flex items-center justify-center px-5 py-2.5 rounded-3xl bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors">
                <span class="font-remote font-[500] text-[14px] text-gray-700">{{ data.closeButton?.label || 'Fechar' }}</span>
            </button>
        </ng-container>
    </div>
</div>
